import React from 'react';
import MainLayout from '../components/layout/MainLayout';
import Section from '../components/ui/Section';
import Button from '../components/ui/Button';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const Success = () => {
  return (
    <MainLayout>
      <Section bg="cream" className="min-h-[60vh] flex items-center">
        <div className="max-w-2xl mx-auto text-center bg-white p-12 rounded-3xl shadow-sm border border-gray-100">
          <div className="w-20 h-20 bg-green-100 text-green-600 rounded-full flex items-center justify-center mx-auto mb-8">
            <SafeIcon icon={FiIcons.FiCheck} className="w-10 h-10" />
          </div>
          <h1 className="text-3xl font-bold text-brand-navy mb-4">Thank you for your purchase!</h1>
          <p className="text-lg text-gray-600 mb-8 leading-relaxed">
            Your e-book is ready. You can download it directly using the link below, and we've also sent a copy to your email.
          </p>
          
          <div className="bg-brand-teal/5 p-6 rounded-2xl border border-brand-teal/20 mb-10">
            <h3 className="font-bold text-brand-navy mb-4">Your Download Link:</h3>
            <Button 
              href="http://bit.ly/43dSvM6" 
              variant="primary" 
              className="py-4 px-8 text-lg"
            >
              <SafeIcon icon={FiIcons.FiDownload} className="mr-2" />
              Download E-Book
            </Button>
          </div>

          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button to="/library" variant="outline">View My Library</Button>
            <Button to="/" variant="ghost">Back to Home</Button>
          </div>
        </div>
      </Section>
    </MainLayout>
  );
};

export default Success;